import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { IframeBlock as Value } from "@reactivated";

type Props = Immutable<{
    value: Value;
}>;

export const IframeBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    return (
        <iframe
            height="600px"
            src={v.url ?? ""}
            title={v.url ?? t`Embedded content`}
            width="100%"
        />
    );
};
